import { render, staticRenderFns } from "./pay-notice-list.vue?vue&type=template&id=92c9d4b6&scoped=true&"
import script from "./pay-notice-list.vue?vue&type=script&lang=js&"
export * from "./pay-notice-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92c9d4b6",
  null
  
)

export default component.exports